/* global axios */
import ApiClient from './ApiClient';

class InboxHealthAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getHealthStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/health`);
  }

  registerWebhook(inboxId) {
    return axios.post(`${this.url}/${inboxId}/register_webhook`);
  }

  getWhatsappProfile(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_profile`);
  }

  updateWhatsappProfile(inboxId, profile) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_profile`, { profile });
  }
}

export default new InboxHealthAPI();
